export default __webpack_public_path__ + "assets/images/8.937a9b.webp";